<!--绩效策略-->
<template>
  <div>
    <div class="title-content" style="display: flex;justify-content: space-between;align-items: center;">
      <div>{{ h_i18n('314ff4bc828852d29650691d73bc5104') }}</div>
      <!-- <h-button-new type="primary" @click="handleVersion" size="middle">切换旧版</h-button-new> -->
    </div>
    <h-list-page class="performance-container">
      <div class="item-module" style="margin-top: 16px;">
        <div class="title-style">{{ h_i18n('9bddda2d3dcbc1842f8c4daf4eb1f038') }}</div>
        <div style="display: flex;flex-direction: row;align-items: center;margin: 16px 0;">
          <div class="marginR20">{{ h_i18n('b8c2123cf539fc379b28f02e782aa3f8') }}{{ myStrategy.qscore || ''}}</div>
          <div class="marginR20">{{ h_i18n('5bcbdcdd47bddaaae5f8d5a85bcdac88') }}{{ myStrategy.qrank }} /{{ myStrategy.allvcode }}</div>
          <div class="primary-btn" @click="handleDetail">{{ h_i18n('5b48dbb8dc710cffe6313bb56a7f6d47') }}</div>
        </div>
        <div class="lose-container" style="">
          <div class="lose-content" style="display: flex;border-bottom: 1px solid #e5e6eb;background: #F1F2F8;">
            <div class="lose-item"></div>
            <div class="lose-item">{{ h_i18n('39f3471d6d7490e532451735a007c7b9') }}</div>
            <div class="lose-item">{{ h_i18n('8d9f49f7ca71bebe79884bff4c1d1564') }}</div>
            <div class="lose-item">{{ h_i18n('dd854a16dcdf535f42974dec3143db43') }}</div>
          </div>
          <div class="lose-content" style="display: flex;border-bottom: 1px solid #e5e6eb;">
            <div class="lose-item" style="padding-left: 16px;">{{ h_i18n('ff7504daf4d477d2591773d973f9a668') }}</div>
            <div class="lose-item">{{myStrategy.xcwasteDay}}</div>
            <div class="lose-item">{{myStrategy.xcwasteMonth}}</div>
            <div class="lose-item">{{ myStrategy.xcwasteYear }}</div>
          </div>
          <div class="lose-content" style="display: flex;">
            <div class="lose-item" style="padding-left: 16px;">{{ h_i18n('7e887ecd01903e9ab4e5c619926cdc3a') }}</div>
            <div class="lose-item">{{myStrategy.scwasteDay}}</div>
            <div class="lose-item">{{myStrategy.scwasteMonth}}</div>
            <div class="lose-item">{{ myStrategy.scwasteYear }}</div>
          </div>
        </div>
      </div>
      <div class="item-module" style="margin-top: 12px;">
        <div class="title-style">{{ h_i18n('f9f974a713225144492248823508721b') }}</div>
        <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
          <div class="btn-container">
            <h-search :title="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" v-show="currentScene == 'day'">
              <h-date-picker v-model="submitDate" type="daterange" :start-placeholder="h_i18n('592c59589144ddc68d05d528da17dcdc')" :end-placeholder="h_i18n('f782779e8b5d709462c8e71e0d9019f2')" clearable @change="handleSubmitDate"/>
            </h-search>
            <h-search :title="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" v-show="currentScene == 'month'">
              <HDatePickerNew type="monthrange" v-model="submitDate" clearable @change="handleSubmitDate" :isShowTitle="true"></HDatePickerNew>
            </h-search>
            <div v-show="currentScene == 'year'" style="display: flex;">
              <h-search :title="h_i18n('592c59589144ddc68d05d528da17dcdc')">
                <h-date-picker type="year" v-model="submitDateStart" clearable @change="handleSubmitDate3"></h-date-picker>
              </h-search>
              <h-search :title="h_i18n('f782779e8b5d709462c8e71e0d9019f2')">
                <h-date-picker type="year" v-model="submitDateEnd" clearable @change="handleSubmitDate4"></h-date-picker>
              </h-search>
            </div>
            <div class="primary-btn" style="margin-left: 4px;" @click="getQualityLine">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</div>
          </div>
          <div class="tabs">
            <div class="tab-item" :class="currentScene=='day'?'selected':''" @click="handleScence('day')">{{ h_i18n('3edddd85ac2c5e612fb71dbb89e7d1c5') }}</div>
            <div class="tab-item" :class="currentScene=='month'?'selected':''" @click="handleScence('month')">{{ h_i18n('e42b99d59954ce6437e66f416850425a') }}</div>
            <div class="tab-item" :class="currentScene=='year'?'selected':''" @click="handleScence('year')">{{ h_i18n('465260fe80b0c3338d06194bb7a94446') }}</div>
          </div>
        </div>
        <qualityLine :yData="yData" :xData="xData"/>
      </div>
      <div class="item-module" style="margin-top: 12px;">
        <div class="title-style">{{ h_i18n('ab6b67f18fb977d99b2e3391ef90d8fd') }}</div>
        <!-- <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;"> -->
        <div class="btn-container">
          <h-search :title="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')">
            <h-date-picker v-model="submitDate2" type="date" :start-placeholder="h_i18n('592c59589144ddc68d05d528da17dcdc')" :end-placeholder="h_i18n('f782779e8b5d709462c8e71e0d9019f2')" clearable @change="handleSubmitDate2"/>
          </h-search>
          <div class="primary-btn" style="margin-left: 4px;" @click="getQualityStrategy">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</div>
        </div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="410" class="myTable"
          :data="productLineArray" size="small" style="width: 100%; min-height: 200px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: 4px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="plName" :label="h_i18n('ebb4b1e6b91d291d055017ecb158011b')" width="80"></el-table-column>
          <el-table-column prop="qscore" :label="h_i18n('b6495723c23af95d5cc5fc85992a2825')"></el-table-column>
          <el-table-column prop="xcWastbl" :label="h_i18n('d66346bdc412a2553258570343b85bac')" width="180">
            <template #default="{row}">
              <span>
                {{ row.xcWastbl ? `${row.xcWastbl }%`: row.xcWastbl}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="scWastbl3m" :label="h_i18n('af0a925beedce958ffd1233709c215f4')" width="180">
            <template #default="{row}">
              <span>
                {{ row.scWastbl3m ? `${row.scWastbl3m }%`: row.scWastbl3m}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="scWastbl6m" :label="h_i18n('5f8d7ec6b9ef1a06d25e9ce515bde33a')" width="180">
            <template #default="{row}">
              <span>
                {{ row.scWastbl6m ? `${row.scWastbl6m }%`: row.scWastbl6m}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="scWastbl12m" :label="h_i18n('f7b259efcb0d775bf03ac957c60218a3')" width="180">
            <template #default="{row}">
              <span>{{ row.scWastbl12m? `${row.scWastbl12m }%`: row.scWastbl12m}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rcDeductscore" :label="h_i18n('10c590a930ccf384da603e2325d1ef12')" width="180"></el-table-column>
          <el-table-column prop="stop4Score" :label="h_i18n('b07a0155d7a2a0c68c6a24f986164c2a')" width="180"></el-table-column>
          <el-table-column prop="zdzlScore" :label="h_i18n('84f28fe48375d53f60e0fd090514f65b')" width="120"></el-table-column>
        </el-table>
      </div>
      <div class="item-module" style="margin-top: 12px;">
        <div class="title-style">{{ h_i18n('7668b49ee48f29cd5ec5d45d0ff51a32') }}</div>
        <div class="red-text" v-show="showTextArray&&showTextArray.length>0" style="margin-right: 40px;"><span v-for="(item,index) in showTextArray" :key="index">{{ item }}{{ h_i18n('a5a6f32c8950b39e8db12ac2a9245f9b') }}</span></div>
        <div class="red-text" v-show="showTextArray&&showTextArray.length>0"><span v-for="(item,index) in showTextArray" :key="index">{{ item }}{{ h_i18n('59596cf5f1da8a37c2870aa9c7cfc3d4') }}</span></div>
        <div class="item-strategy">
          <div class="strategy1">{{ h_i18n('396cd17968db99012e4b3e306b3f0c4d') }}</div>
          <div class="strategy2">{{ h_i18n('f1f46525bece70cb3f788cae203c99a2') }}</div>
          <div class="strategy3">
            <el-radio-group v-model="detailObj.changestatus" disabled>
              <el-radio label="1">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="2">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="item-strategy">
          <div class="strategy1">{{ h_i18n('5f3ca6758c15ef228ff66160911d8066') }}</div>
          <div class="strategy2">
            <div>{{ h_i18n('a26b5f0cbe0ad2f81e3d098c46302f9a') }}</div>
            <div>{{ h_i18n('addfd08e15077a55aa459049ea84a6b3') }}</div>
            <div>{{ h_i18n('e7b5c9b72bf29e6ca0217feec3f42676') }}</div>
          </div>
          <div class="strategy3">
            <div>
              <el-radio-group v-model="detailObj.xinpinStatus1" disabled>
                <el-radio :label="1">{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}</el-radio>
                <el-radio :label="2">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-radio-group v-model="detailObj.xinpinStatus2" disabled>
                <el-radio label="1">{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}</el-radio>
                <el-radio label="2">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-radio-group v-model="detailObj.xinpinStatus3" disabled>
                <el-radio label="1">{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}</el-radio>
                <el-radio label="3" >{{ h_i18n('895558d952f104b8af7cc7fa9dc20f68') }}</el-radio>
                <el-radio label="2">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="item-strategy">
          <div class="strategy1">{{ h_i18n('4c117f2037181c74559db1829298e041') }}</div>
          <div class="strategy2">
            <div>{{ h_i18n('83a4d6f70bb36017c0e124f02d7c3137') }}</div>
            <div>{{ h_i18n('a569f8867cac701f530c3c4705a3ed91') }}</div>
            <div>{{ h_i18n('692025eea9335009f3679eb5c52438b7') }}</div>
          </div>
          <div class="strategy3">
            <div>
              <el-radio-group v-model="detailObj.orderStatus1" disabled>
                <el-radio label="1">{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}</el-radio>
                <el-radio label="2">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-radio-group v-model="detailObj.orderStatus2" disabled>
                <el-radio label="1">{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}</el-radio>
                <el-radio label="2">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-radio-group v-model="detailObj.orderStatus3" disabled>
                <el-radio label="1">{{ h_i18n('8e1a4fc6d6362b0e5921df948355ca7a') }}</el-radio>
                <el-radio label="0">{{ h_i18n('5f3327477d147e70a6aa8eee8fc9ae2b') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <el-dialog ref="addReasonNameRef" :title="h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca')" v-model="showDialog" width="720px" @close="handleCancel">
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="360" class="myTable"
          :data="yhpjtc" size="small" style="width: 100%; min-height: 360px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: -14px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="groupname" :label="h_i18n('4e8365b7b7ef302d07d644229cb3055c')"></el-table-column>
          <el-table-column prop="showvcode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')"></el-table-column>
          <el-table-column prop="showvname" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')"></el-table-column>
          <el-table-column prop="showscore" :label="h_i18n('b6495723c23af95d5cc5fc85992a2825')"></el-table-column>
          <el-table-column prop="showrank" :label="h_i18n('70073813fad2e6cca25bdddc7f0c0d7f')"></el-table-column>
        </el-table>
      </el-dialog>
    </h-list-page>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
import qualityLine from './components/qualityLine'
import  HDatePickerNew from '@/views/Templates/h-date-picker-new'

export default {
  data(){
    return{
      submitDate:[],
      currentScene:'day',
      yData:[],
      xData:[],
      detailObj:{
        changestatus:null,
        xinpinStatus1:null,
        xinpinStatus2:null,
        xinpinStatus3:null,
        orderStatus1:null,
        orderStatus2:null,
        orderStatus3:'0'
      },
      submitDate2:'',
      submitDateStart:null,
      submitDateEnd:null,
      productLineArray:[],// 产品线质量绩效
      isShowText: false,
      showTextArray:[],
      myStrategy:{},
      yhpjtc:[],
      showDialog: false,
      loseObj: [], // 市场/现场损失
    }
  },
  components:{
    qualityLine,HDatePickerNew
  },
  methods:{
    h_i18n,
    handleScence(val){
      this.currentScene = val
      this.getQualityLine()
    },
    handleSubmitDate(val){
      this.submitDate = []
      if(val&&val.length>0){
        this.submitDate = [...val]
      }else{
        this.submitDate = []
      }
    },
    // 质量绩效走势
    getQualityLine(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.xData = []
      this.yData = []
      let url = ''
      if(this.currentScene=='day'){
        url='/base/userevaluation/getScoreDay'
      }else if(this.currentScene=='month'){
        url='/base/userevaluation/getScoreMonth'
      }else if(this.currentScene=='year'){
        url='/base/userevaluation/getScoreYear'
      }else{
        url='/base/userevaluation/getScoreDay'
      }
      let params = {}
      console.log("(this.submitDate&&this.submitDate.length>0)&&this.currentScene=='day'",(this.submitDate&&this.submitDate.length>0)&&this.currentScene=='day')
      if((this.submitDate&&this.submitDate.length>0)&&this.currentScene=='day'){
        params.start = moment(this.submitDate[0]).format("YYYY-MM-DD 00:00:00")
        params.end = moment(this.submitDate[1]).format("YYYY-MM-DD 23:59:59")
      }
      console.log("(this.submitDate2&&this.submitDate2.length>0)&&this.currentScene=='month'",(this.submitDate&&this.submitDate.length>0)&&this.currentScene=='month')
      if((this.submitDate&&this.submitDate.length>0)&&this.currentScene=='month'){
        params.start = moment(this.submitDate[0]).format("YYYY-MM-01")
        params.end = moment(this.submitDate[1]).format("YYYY-MM-01")
      }
      console.log("(this.submitDateStart&&this.submitDateEnd)&&this.currentScene=='year'",(this.submitDateStart&&this.submitDateEnd)&&this.currentScene=='year')
      if((this.submitDateStart&&this.submitDateEnd)&&this.currentScene=='year'){
        params.start = this.submitDateStart
        params.end = this.submitDateEnd
      }
      this.$http({
        method: "post",
        url: url,
        params:{
          ...params,
          vcode:this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        }
      }).then((res) => {
        this.closeLoading()
        this.$nextTick(()=>{
          if(this.currentScene=='day'){
            this.xData = res&&res.data&&res.data.data&&res.data.data.timeday||[]
            this.yData = res&&res.data&&res.data.data&&res.data.data.scoreday||[]
          }else if(this.currentScene=='month'){ 
            this.xData = res&&res.data&&res.data.data&&res.data.data.timemonth||[]
            this.yData = res&&res.data&&res.data.data&&res.data.data.scoremonth||[]
          }else if(this.currentScene=='year'){
            this.xData = res&&res.data&&res.data.data&&res.data.data.timeyear||[]
            this.yData = res&&res.data&&res.data.data&&res.data.data.scoreyear||[]
          }else{
            this.xData = res&&res.data&&res.data.data&&res.data.data.timeday||[]
            this.yData = res&&res.data&&res.data.data&&res.data.data.scoreday||[]
          }
        })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    // 绩效策略-产品线质量绩效
    getQualityStrategy(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: '/base/userevaluation/getCPXInfo',
        params: {
          time:this.submitDate2 ? moment(this.submitDate2).format("YYYY-MM-DD") : '',
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        },
      }).then((res) => {
        this.$nextTick(()=>{
          this.productLineArray = res&&res.data&&res.data.data&&res.data.data.length>0 ? [...res.data.data] : []
          let WarmFlag=0;
          let tmp = [...this.productLineArray]
          if(tmp&&tmp.length>0){
            
            tmp.forEach(e => {
              if(Number(e.qscore)<60){
                WarmFlag==1
                this.isShowText = true
                this.detailObj.changestatus = '1'
                this.detailObj.xinpinStatus3 = '3'
                this.showTextArray.push(e.plName)
              }
            })
          }
        })  
        this.closeLoading()
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleSubmitDate2(val){
      if(val){
        this.submitDate2 = val
      }else{
        this.submitDate2 = ''
      }
    },
    handleSubmitDate3(val){
      this.submitDateStart = moment(val).format("YYYY-12-31")
    },
    handleSubmitDate4(val){
      this.submitDateEnd = moment(val).format("YYYY-12-31")
    },
    // /base/userevaluation/getStopCheckSatus
    getStopCheckSatusData(){
      let self = this
      self.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      self.$http({
        method: "post",
        url: '/base/userevaluation/getStopCheckSatus',
        params: {
          vcode: self.$route.query.supplyCode||self.$route.query.vCode||self.$route.query.vcode,
        },
      }).then((res) => {
        self.$nextTick(()=>{
          self.detailObj.orderStatus3 = String(res.data.data)
        })  
        self.closeLoading()
      }).catch(err=>{
        self.closeLoading()
        self.info(err.data.msg)
      })
    },
    // 我的质量绩效
    getMainTopData(){
      let self = this
      self.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      self.$http({
        method: "post",
        url: '/base/userevaluation/getMainTop',
        params: {
          vcode: self.$route.query.supplyCode||self.$route.query.vCode||self.$route.query.vcode,
        },
      }).then((res) => {
        console.log('rererererr加下哦',res)
        self.myStrategy = res.data.data.yhpjtop || {}
        self.yhpjtc = res.data.data.yhpjtc
        self.closeLoading()
      }).catch(err=>{
        self.closeLoading()
        self.info(err.data.msg)
      })
    },
    // 我的质量绩效
    getSCShunShiData(){
      let self = this
      self.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      self.$http({
        method: "post",
        url: '/base/userevaluation/getSCShunShi',
        params: {
          vcode: self.$route.query.supplyCode||self.$route.query.vCode||self.$route.query.vcode,
        },
      }).then((res) => {
        console.log('rerererereregetSCShunShi',res)
        if(res.data.code == 0){
          self.loseObj = res.data.data[0] || []
          console.log('self.loseObj',self.loseObj)
        }
        self.closeLoading()
      }).catch(err=>{
        self.closeLoading()
        self.info(err.data.msg)
      })
    },
    handleDetail(){
      this.showDialog = true
    },
    handleCancel(){
      this.showDialog = false
    },
    handleVersion(){
      const vCode = this.$route.query.supplyCode 
      const supplyCode = this.$route.query.supplyCode 
      const vName = this.$route.query.vName
      const resourceId = this.$route.query.resourceId
      const roleCode = this.$route.query.roleCode
      const roleId = this.$route.query.roleId
      const name = this.$route.query.name
      const nickName = this.$route.query.nickName
      const trueName = this.$route.query.trueName
      const supplyName = this.$route.query.supplyName
      const userName = this.$route.query.userName
      const dataFrom = this.$route.query.dataFrom
      if (process.env.NODE_ENV != 'production') {
        window.open("https://t-api-cn-sp000339-bridge-i.hwork.haier.net/performance/performance_supplier?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId+"&supplyCode="+supplyCode
          +"&roleCode="+roleCode+"&supplyCode="+vCode+"&roleId="+roleId+"&name="+name+"&nickName="+nickName+"&trueName="+trueName+"&supplyName="+supplyName+"&userName="+userName+"&dataFrom="+dataFrom
        )
      }else{
        window.open("https://sqm.haier.net/performance/performance_supplier?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId+"&supplyCode="+supplyCode
          +"&roleCode="+roleCode+"&supplyCode="+vCode+"&roleId="+roleId+"&name="+name+"&nickName="+nickName+"&trueName="+trueName+"&supplyName="+supplyName+"&userName="+userName+"&dataFrom="+dataFrom
        )
      }
    }
  },
  mounted(){
    this.submitDate2 = moment().subtract(2, 'days').format('YYYY-MM-DD')

    this.getMainTopData()
    this.getSCShunShiData()
    this.getQualityLine()
    this.getQualityStrategy()
    this.getStopCheckSatusData()
  }
}
</script>

<style lang="scss" scoped>
.title-content{
  box-sizing: border-box;
  background: #fff;
  height: 56px;
  line-height: 56px;
  color: #1D2129;
  font-size: 18px;
  padding: 0 16px;
}
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}
.performance-container{
  padding: 0 16px 16px;
  .item-module{
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    padding: 13px 16px 16px;
  }
  .title-style{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    color: #1D2129;
    font-weight: bold;
  }
  .btn-container{
    display: flex;
    flex-direction: row;
    margin-top: 12px;
  }
  .item-strategy{
    box-sizing: border-box;
    border: 1px solid #E5E6EB;
    border-radius: 8px;
    width: 100%;
    display: flex;
    margin-top: 16px;
  }
  .strategy1{
    width: 20%;
    padding: 16px;
    border-right: 1px solid #E5E6EB;
  }
  .strategy2{
    width: 50%;
    padding: 16px;
    border-right: 1px solid #E5E6EB;
  }
  .strategy3{
    width: 30%;
    padding: 16px;
  }
}
.primary-btn{
  box-sizing: border-box;
  min-width: 60px;
  max-width: 90px;
  height: 32px !important;
  line-height: 32px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#165DFF;
  color: #165dff;
  border-radius: 6px;
  font-size: 14px;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.tabs{
  box-sizing: border-box;
  background: #F2F3F5;
  width: 68px;
  height: 28px;
  line-height: 22px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  padding: 3px;
  
  .tab-item{
    width: 28px;
    height: 22px;
    line-height: 22px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
  }
  .selected{
    display: inline-block;
    background: #fff;
    font-size: 12px;
    color: #165dff;
  }
}
.red-text{
  color: #F53F3F;
  font-size: 14px;
  display: inline-block;
  margin-top: 16px;
}

.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color:#e5e6eb !important;
}
.lose-container{
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  width: 100%;
  .lose-content{
    display: flex;
    .lose-item{
      width: 25%;
      height: 40px;
      line-height: 40px;
    }
  }
}
.marginR20{
  margin-right: 20px;
}
</style>

<style scoped>
.haier-list-page .el-table--border, .haier-list-page .haier-list-page .el-table--group{
  border-right: none;
  border-bottom: none;
}
</style>